import { writable, Writable } from 'svelte/store'
import type { FeaturesData } from '../api/models.d.js'

export interface CurrentUser {
  id: string
  fullName: string
  hasPhoto?: boolean
  thumbnail: string
  thumbnailBackground: string
  channelId?: string
  isContentAdmin: boolean
  isGatewayAdmin: boolean
  isSupportAdmin: boolean
  canCreateDefinition: boolean
  bookmarkCount: number
  groupMembershipCount: number
  galleryCount: number
  mapCount: number
  datasetCount: number
  definitionCount: number
  documentCount: number
}

export const currentUser: Writable<CurrentUser | null> = writable(null)
export const unreadMessages: Writable<number> = writable(0)
export const unreadNotifications: Writable<number> = writable(0)
export const features: Writable<FeaturesData | null> = writable(null)
